import React from 'react'
import { StyleProp, StyleSheet, Text, TextInput, TextStyle, View, ViewStyle } from 'react-native'
import { corporateColor, grayBorders, inputTextColor, placeholderColor } from '../../theme/colors'
import { DOBRA } from '../../theme/fonts'

interface Props {
  label?: string
  value: string
  placeholder?: string
  onChange: (value: string) => void
  onBlur?: () => void
  keyboardType?: 'numeric' | 'default'
  readonly?: boolean
  multiline?: boolean
  maxLength?: number
  customStyles?: {
    container?: StyleProp<ViewStyle>
    input?: StyleProp<TextStyle>
  }
}

export const TextInputComponent = ({
  onChange,
  label,
  value,
  keyboardType,
  readonly,
  customStyles,
  placeholder,
  onBlur,
  multiline,
  maxLength,
}: Props) => {
  return (
    <View style={customStyles?.container}>
      {label && <Text style={style.label}>{label}</Text>}
      <TextInput
        onChangeText={onChange}
        value={value}
        placeholder={placeholder ?? 'Ingresar'}
        keyboardType={keyboardType ?? 'default'}
        style={[style.input, customStyles?.input]}
        placeholderTextColor={placeholderColor}
        readOnly={readonly}
        onBlur={onBlur}
        multiline={multiline}
        maxLength={maxLength}
      />
    </View>
  )
}

const style = StyleSheet.create({
  label: {
    fontFamily: DOBRA,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: corporateColor,
  },
  input: {
    height: 42,
    borderWidth: 1,
    padding: 12,
    borderRadius: 8,
    borderColor: grayBorders,
    fontFamily: DOBRA,
    marginTop: 4,
    fontWeight: '400',
    fontSize: 14,
    color: inputTextColor,
  },
})
